import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { motion } from 'framer-motion';

/**
 * RelatedByTags Component - Sidebar Version
 * 
 * Shows 5 related articles based on shared tags.
 * Designed to fit in the sidebar layout.
 */
export const RelatedByTags = ({
    currentArticle,
    allArticles = [],
    maxArticles = 5
}) => {
    if (!currentArticle || !allArticles.length) return null;

    // Get tag-based related articles
    const currentTags = new Set(currentArticle.tags || []);
    const tagRelated = allArticles
        .filter(a =>
            a.id !== currentArticle.id &&
            a.tags?.some(tag => currentTags.has(tag))
        )
        .slice(0, maxArticles);

    if (tagRelated.length === 0) return null;

    return (
        <div className="glass rounded-xl p-6 border border-white/10">
            <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">
                More From This Topic
            </h3>
            <ul className="space-y-1">
                {tagRelated.map((article, index) => (
                    <motion.li
                        key={article.id}
                        initial={{ opacity: 0, x: -5 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.05 }}
                    >
                        <Link
                            to={article.canonicalPath || `/blog/${article.slug}`}
                            className="flex items-start gap-2 p-2 -mx-2 rounded-lg hover:bg-white/5 transition-colors group"
                        >
                            <div className="w-1.5 h-1.5 rounded-full bg-white/20 group-hover:bg-primary transition-colors mt-2 flex-shrink-0" />
                            <span className="text-sm group-hover:text-primary transition-colors line-clamp-2">
                                {article.title}
                            </span>
                        </Link>
                    </motion.li>
                ))}
            </ul>
        </div>
    );
};

export default RelatedByTags;
